import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultTextValues, textSchema } from '../../Text/model/TextSchema';

export const originalBookAuthorSchema = z.object({
  authorName: z.string().min(3),
  membership: identitySchema,
});

export const translationSchema = textSchema.extend({
  type: identitySchema.nullable(),
  bookName: z.string().nullable(),
  bookAuthors: z.array(originalBookAuthorSchema),
  authors: z.array(authorSchema).min(1),
});

export const defaultTranslationValues: DefaultValues<TranslationSchema> = {
  authors: [],
  bookAuthors: [],
  bookName: '',
  type: null,
  ...defaultTextValues,
};

export type TranslationSchema = z.infer<typeof translationSchema>;
export type OriginalBookAuthorSchema = z.infer<typeof originalBookAuthorSchema>;
